import React from 'react';
import { usePathname } from 'expo-router';

import { Button } from '../button';

import { useFeedbackModal } from '@/providers/modal/feedback-modal';
import { capitalize } from '@/utils/capitalize';

export const SendFeedback = React.memo(() => {
  const feedbackModal = useFeedbackModal();

  const pathname = usePathname();
  const demoName = pathname?.split('/demos/')?.[1];

  const title = demoName?.split('-')?.map(capitalize)?.join(' ');

  return (
    <div className="w-full mt-8">
      <div
        className={`
        bg-background-400/50 backdrop-blur-sm rounded-xl pt-6 pb-4 px-6
        border transition-all duration-300 select-none
        border-background-300 hover:border-background-200
      `}
      >
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-6 h-6 flex items-center justify-center text-subtle-400">
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                className="w-full h-full"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"
                />
              </svg>
            </div>
            <h2 className="text-base font-normal text-subtle-400">
              {title ? `${title} - Feedback` : 'Feedback'}
            </h2>
          </div>
          <div className="px-3 py-1 rounded-full text-xs select-none bg-background-300/50 text-subtle-700">
            Share Your Thoughts
          </div>
        </div>

        <p className="mb-4 text-sm text-subtle-700 select-text">
          I value a lot your feedback! Help me improve by sharing your thoughts,
          suggestions, or reporting any issues you encounter. If you need
          assistance, send me an email at hello@reactiive.io
        </p>

        <Button
          variant="outline"
          className="w-full justify-center"
          onClick={feedbackModal.open}
        >
          Send Feedback
        </Button>
      </div>
    </div>
  );
});
